import './NotFoundPage.scss';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import RobotJeen from '../../assets/robot-jeen.svg';
import JeenIcon from '../../assets/main-logo.svg';
import GoBackIcon from '../../assets/go-back-icon.svg';
import FilledBtn from '../../cmps/FilledBtn/FilledBtn';
import { useAtom } from 'jotai';
import { isBotFoundAtom } from '../../atoms/general';

// import axios from '@/configs/axios';
// import { refreshUserJwtToken } from '@/api/jwt.js';
// import { logout } from '@/actions/auth.action';
// import { finishedLoginAtom, loginUser } from '@/api/users';
// import { userAtom, loginConfigAtom} from '@/atoms/general';

const NotFoundPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setIsBotFound] = useAtom(isBotFoundAtom);

  // const [finishedLogin] = useAtom(finishedLoginAtom);
  // const [user] = useAtom(userAtom);
  // const [loginConfig] = useAtom(loginConfigAtom);

  useEffect(() => {
    console.error(`404 Error: User attempted to access non‑existent route: ${location.pathname}`);
  }, [location.pathname]);

  // const handelLogin = async () => {

  //       const sessionUser = user || sessionStorage.getItem('user');
  //       if (!sessionUser || !sessionUser.email) {
  //         console.warn('No user found in session');
  //         return false;
  //       }
  //       const sessionUserMatches = sessionUser && sessionUser.email === user?.email
  //       if(!sessionUserMatches) {
  //           return false
  //       }
  //       if (!finishedLogin) {
  //           const refreshToken = await refreshUserJwtToken();
  //           if (!refreshToken) {
  //               const data = await loginUser(sessionUser.email, loginConfig.config);
  //               if (!data || !data.token) {
  //                 return false;
  //               }
  //               axios.updateAxiosToken(data.token);
  //           }
  //       } else {
  //         const refreshed = await refreshUserJwtToken();
  //         if (!refreshed) {
  //           logout()
  //           return false;
  //         }
  //       }
  //     }

  const handleBack = async () => {
    setIsBotFound(true);
    navigate('/');
  };

  return (
    <section className="not-found">
      <div className="not-found-image">
        <img src={RobotJeen} alt="Jeen the friendly robot" />
      </div>

      <div className="not-found-content">
        <h1 id="page-title">404</h1>
        <p>
          Oops! We ran into a problem.
          <br />
          Try to return to the main page again.
        </p>

        <FilledBtn onClick={handleBack}>
          <img src={GoBackIcon} alt="Go Back Icon" />
          Return
        </FilledBtn>
      </div>
      <footer className="not-found-footer">
        <span>Created by</span>
        <img src={JeenIcon} alt="Jeen icon" className="jeen-icon" />
      </footer>
    </section>
  );
};

export default NotFoundPage;
